import { BILLING_ROUTES } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

interface AnalyticsPayload {
  startDate: string;
  endDate: string;
}

const getAnalyticsApi = createAsyncThunk(
  'getAnalyticsApi',
  async (payload: AnalyticsPayload, { rejectWithValue }) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const url = `${BILLING_ROUTES.REPORTING_ANALYTICS.get}`;

      const response = await fetch(url, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          startDate: payload.startDate,
          endDate: payload.endDate
        }),
      });

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export default getAnalyticsApi;
